<template>
  <div class="album-desc">
    <div class="title"><span>概要</span><img :class="[isSub?'':'top']" @click="openHandle" src="@/assets/icon_jump.png"></div>
    <!-- <div :class="['desc', isSub?'':'all']">{{ isSub?substring(desc, 50, true):desc }}</div> -->
    <div :class="['desc', isSub?'':'all']" v-html="isSub?substringKeepHtml(desc, 50, true):desc"></div>
  </div>
</template>

<script>
import { substringKeepHtml } from '@/utils/index'
export default {
  name: 'AlbumDesc',
  components: {
  },
  props: {
    desc: { 
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSub: true
    }
  },
  methods: {
    openHandle(){
      this.isSub = !this.isSub
    },
    substringKeepHtml
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.album-desc{
    background-color: #fff;
    text-align: left;
    padding: 16px 16px 0 16px;
    .title{
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      img{
        width: 16px;
        height: 18px;
        transform: rotate(90deg);
        transition: transform 0.15s ease-out;
        &.top{
            transform: rotate(-90deg);
            transition: transform 0.15s ease-in;
        }
      }
    }
    .desc{
      color: #666;
      font-size: 14px;
      line-height: 20px;
      max-height: 45px;
      transition: max-height 0.15s ease-out;
      &.all{
        max-height: 1000px;
        transition: max-height 0.15s ease-in;
      }
    }
}
</style>
